(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["warmcore-applications-immersive"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const defaults = {
      'ai-development':['https://cdn.shopify.com/s/files/1/0634/6512/8035/files/ai-development.webp?v=1783405661','https://cdn.shopify.com/s/files/1/0634/6512/8035/files/ai-development-bg.webp?v=1783405663'],
      'education':['https://cdn.shopify.com/s/files/1/0634/6512/8035/files/education.webp?v=1783405662','https://cdn.shopify.com/s/files/1/0634/6512/8035/files/education-bg.webp?v=1783405661'],
      'elder-care':['https://cdn.shopify.com/s/files/1/0634/6512/8035/files/elder-care.webp?v=1783405662','https://cdn.shopify.com/s/files/1/0634/6512/8035/files/elder-care-bg.webp?v=1783405662'],
      'hospital-reception':['https://cdn.shopify.com/s/files/1/0634/6512/8035/files/hospital-reception.webp?v=1783405662','https://cdn.shopify.com/s/files/1/0634/6512/8035/files/hospital-reception-bg.webp?v=1783405662'],
      'hotel-reception':['https://cdn.shopify.com/s/files/1/0634/6512/8035/files/hotel-reception.webp?v=1783405662','https://cdn.shopify.com/s/files/1/0634/6512/8035/files/hotel-reception-bg.webp?v=1783405662'],
      'museum-guide':['https://cdn.shopify.com/s/files/1/0634/6512/8035/files/museum-guide.webp?v=1783405661','https://cdn.shopify.com/s/files/1/0634/6512/8035/files/museum-guide-bg.webp?v=1783405661'],
      'kol-live-streaming':['https://cdn.shopify.com/s/files/1/0634/6512/8035/files/kol-live-streaming.webp?v=1783405661','https://cdn.shopify.com/s/files/1/0634/6512/8035/files/kol-live-streaming-bg.webp?v=1783405662'],
      'meeting-assistant':['https://cdn.shopify.com/s/files/1/0634/6512/8035/files/meeting-assistant.webp?v=1783405661','https://cdn.shopify.com/s/files/1/0634/6512/8035/files/meeting-assistant-bg.webp?v=1783405662'],
      'office-reception':['https://cdn.shopify.com/s/files/1/0634/6512/8035/files/office-reception.webp?v=1783405661','https://cdn.shopify.com/s/files/1/0634/6512/8035/files/office-reception-bg.webp?v=1783405663'],
      'personal-companion':['https://cdn.shopify.com/s/files/1/0634/6512/8035/files/personal-companion.webp?v=1783405662','https://cdn.shopify.com/s/files/1/0634/6512/8035/files/personal-companion-bg.webp?v=1783405676']
    };
    const initialized = new WeakSet();
    function init(root) {
      if (!root || initialized.has(root)) return;
      initialized.add(root);
      const scenes = [...root.querySelectorAll('[data-wc-ia-scene]')];
      if (!scenes.length) return;
      const image = root.querySelector('[data-wc-ia-image]'); const background = root.querySelector('[data-wc-ia-background]'); const dots = root.querySelector('[data-wc-ia-dots]');
      const set = (selector, value) => { const el = root.querySelector(selector); if (el) el.textContent = value || ''; };
      const pad = value => String(value).padStart(2, '0'); let index = 0; let timer; const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const render = (next) => { index = (next + scenes.length) % scenes.length; const scene = scenes[index]; const fallback = defaults[scene.dataset.key] || defaults['personal-companion']; const src = scene.dataset.image || fallback[0]; const bg = scene.dataset.background || fallback[1]; if (image) { image.src = src; image.alt = `${scene.dataset.title || 'Warmcore application'} application scene`; } if (background) background.style.backgroundImage = `url("${bg}")`; set('[data-wc-ia-category]', scene.dataset.category); set('[data-wc-ia-title]', scene.dataset.title); set('[data-wc-ia-description]', scene.dataset.description); set('[data-wc-ia-proof]', scene.dataset.proof); set('[data-wc-ia-status-title]', scene.dataset.title); set('[data-wc-ia-count]', `${pad(index + 1)} / ${pad(scenes.length)}`); const link = root.querySelector('[data-wc-ia-link]'); if (link) link.href = scene.dataset.link || '#'; scenes.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === index)); [...dots.children].forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === index)); if (window.matchMedia('(max-width: 760px)').matches) scene.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'nearest', inline: 'center' }); };
      const stop = () => window.clearTimeout(timer); const schedule = () => { stop(); if (reduced) return; timer = window.setTimeout(() => { render(index + 1); schedule(); }, Number(root.dataset.autoplayMs || 5000)); };
      scenes.forEach((scene, sceneIndex) => { const dot = document.createElement('button'); dot.type = 'button'; dot.setAttribute('aria-label', scene.dataset.title || `Application ${sceneIndex + 1}`); dot.addEventListener('click', () => { render(sceneIndex); schedule(); }); dots.appendChild(dot); scene.addEventListener('click', () => { render(sceneIndex); schedule(); }); });
      root.querySelector('[data-wc-ia-prev]')?.addEventListener('click', () => { render(index - 1); schedule(); }); root.querySelector('[data-wc-ia-next]')?.addEventListener('click', () => { render(index + 1); schedule(); }); render(0); if ('IntersectionObserver' in window) new IntersectionObserver(entries => entries.forEach(entry => entry.isIntersecting ? schedule() : stop()), { rootMargin: '-25% 0px' }).observe(root); else schedule();
    }
    const initAll = scope => (scope || document).querySelectorAll('[data-wc-ia-parity]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document)); else initAll(document);
    document.addEventListener('shopify:section:load', event => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warmcore-applications"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialized = new WeakMap();
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function initWarmcoreApplications(root) {
      if (!root || initialized.has(root)) return;

      const sceneScript = root.querySelector("[data-wc-ia-scenes]");
      if (!sceneScript) return;

      let scenes = [];
      try {
        scenes = JSON.parse(sceneScript.textContent || "[]").filter((scene) => scene && scene.image && scene.background);
      } catch (error) {
        return;
      }

      if (!scenes.length) return;

      const els = {
        bgA: root.querySelector("[data-bg-a]"),
        bgB: root.querySelector("[data-bg-b]"),
        card: root.querySelector("[data-main-card]"),
        mainImage: root.querySelector("[data-main-image]"),
        mainCategory: root.querySelector("[data-main-category]"),
        mainCount: root.querySelector("[data-main-count]"),
        mainTitle: root.querySelector("[data-main-title]"),
        mainDescription: root.querySelector("[data-main-description]"),
        mainLink: root.querySelector("[data-main-link]"),
        mainProofTitle: root.querySelector("[data-main-proof-title]"),
        mainProofCopy: root.querySelector("[data-main-proof-copy]"),
        railIndex: root.querySelector("[data-rail-index]"),
        railTitle: root.querySelector("[data-rail-title]"),
        prevButtons: Array.from(root.querySelectorAll("[data-prev]")),
        nextButtons: Array.from(root.querySelectorAll("[data-next]")),
        dots: root.querySelector("[data-dots]")
      };

      let activeIndex = 0;
      let visibleBg = 0;
      let animating = false;
      let autoplayTimer = null;
      let hasEnteredViewport = false;
      let autoplayActive = false;
      let observer = null;

      const proofLabel = root.dataset.proofLabel || "Application Scene";
      const proofFallback = root.dataset.proofFallback || "Practical application scene";
      const wrap = (index) => (index + scenes.length) % scenes.length;
      const imageText = (scene) => scene.title + " application scene";
      const twoDigit = (index) => String(index + 1).padStart(2, "0");

      scenes.forEach((scene) => {
        const img = new Image();
        img.src = scene.image;
        const bg = new Image();
        bg.src = scene.background || scene.image;
      });

      function setText(selector, value) {
        const el = root.querySelector(selector);
        if (el) el.textContent = value || "";
      }

      function setPreview(kind, index) {
        const scene = scenes[index];
        const image = root.querySelector(`[data-preview-${kind}-image]`);
        if (image) {
          image.src = scene.image;
          image.alt = imageText(scene);
        }
        setText(`[data-preview-${kind}-category]`, scene.category);
        setText(`[data-preview-${kind}-title]`, scene.title);
        setText(`[data-preview-${kind}-description]`, scene.description);
      }

      function buildDots() {
        if (!els.dots) return;
        els.dots.innerHTML = "";
        scenes.forEach((scene, index) => {
          const button = document.createElement("button");
          button.type = "button";
          button.className = "wc-ia-dot";
          button.setAttribute("aria-label", scene.title);
          button.addEventListener("click", () => {
            goTo(index, index > activeIndex ? 1 : -1, true);
          });
          els.dots.appendChild(button);
        });
      }

      function updateDots() {
        if (!els.dots) return;
        Array.from(els.dots.children).forEach((dot, index) => {
          dot.setAttribute("aria-current", index === activeIndex ? "true" : "false");
        });
      }

      function renderContent(index) {
        const scene = scenes[index];
        const farPrevIndex = wrap(index - 2);
        const prevIndex = wrap(index - 1);
        const nextIndex = wrap(index + 1);
        const farNextIndex = wrap(index + 2);

        if (els.mainImage) {
          els.mainImage.src = scene.image;
          els.mainImage.alt = imageText(scene);
        }
        if (els.mainCategory) els.mainCategory.textContent = scene.category || "";
        if (els.mainCount) els.mainCount.textContent = twoDigit(index) + " / " + twoDigit(scenes.length - 1);
        if (els.mainTitle) els.mainTitle.textContent = scene.title || "";
        if (els.mainDescription) els.mainDescription.textContent = scene.description || "";
        if (els.mainLink) els.mainLink.href = scene.link || "#";
        if (els.mainProofTitle) els.mainProofTitle.textContent = proofLabel;
        if (els.mainProofCopy) els.mainProofCopy.textContent = scene.proof || proofFallback;
        if (els.railIndex) els.railIndex.textContent = twoDigit(index) + " / " + twoDigit(scenes.length - 1);
        if (els.railTitle) els.railTitle.textContent = scene.title || "";

        setPreview("far-prev", farPrevIndex);
        setPreview("prev", prevIndex);
        setPreview("next", nextIndex);
        setPreview("far-next", farNextIndex);
        updateDots();
      }

      function setBackground(index) {
        const current = visibleBg === 0 ? els.bgA : els.bgB;
        const next = visibleBg === 0 ? els.bgB : els.bgA;
        if (!current || !next) return;
        next.style.backgroundImage = `url("${scenes[index].background || scenes[index].image}")`;
        current.classList.remove("is-visible");
        next.classList.add("is-visible");
        visibleBg = visibleBg === 0 ? 1 : 0;
      }

      function clearAutoplayTimer() {
        if (autoplayTimer) {
          window.clearTimeout(autoplayTimer);
          autoplayTimer = null;
        }
      }

      function scheduleAutoplay() {
        if (!autoplayActive || reduceMotion) return;
        clearAutoplayTimer();
        autoplayTimer = window.setTimeout(() => {
          autoplayTimer = null;
          goTo(activeIndex + 1, 1, false);
        }, 3000);
      }

      function startAutoplay() {
        if (reduceMotion) return;
        autoplayActive = true;
        if (!autoplayTimer && !animating) {
          scheduleAutoplay();
        }
      }

      function stopAutoplay() {
        autoplayActive = false;
        clearAutoplayTimer();
      }

      function revealSection() {
        if (root.classList.contains("is-ready")) return;
        window.requestAnimationFrame(() => {
          root.classList.add("is-ready");
        });
      }

      function goTo(nextIndex, direction = 1, userInitiated = false) {
        nextIndex = wrap(nextIndex);
        if (nextIndex === activeIndex || animating) return;

        if (userInitiated) {
          clearAutoplayTimer();
        }

        animating = true;
        setBackground(nextIndex);
        root.classList.add("is-switching");

        window.setTimeout(() => {
          activeIndex = nextIndex;
          renderContent(activeIndex);
          root.classList.remove("is-switching");
          animating = false;
          scheduleAutoplay();
        }, 320);
      }

      function handleKeydown(event) {
        if (!root.classList.contains("is-ready")) return;
        if (event.key === "ArrowLeft") goTo(activeIndex - 1, -1, true);
        if (event.key === "ArrowRight") goTo(activeIndex + 1, 1, true);
      }

      buildDots();
      if (els.bgA) els.bgA.style.backgroundImage = `url("${scenes[0].background || scenes[0].image}")`;
      renderContent(activeIndex);

      if ("IntersectionObserver" in window) {
        observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              revealSection();
              if (!hasEnteredViewport) {
                hasEnteredViewport = true;
                if (activeIndex !== 0) {
                  activeIndex = 0;
                  setBackground(0);
                  renderContent(0);
                }
              }
              startAutoplay();
            } else {
              stopAutoplay();
            }
          });
        }, { rootMargin: "-28% 0px -28% 0px", threshold: 0 });

        observer.observe(root);
      } else {
        revealSection();
        startAutoplay();
      }

      els.prevButtons.forEach((button) => {
        button.addEventListener("click", () => goTo(activeIndex - 1, -1, true));
      });

      els.nextButtons.forEach((button) => {
        button.addEventListener("click", () => goTo(activeIndex + 1, 1, true));
      });

      window.addEventListener("keydown", handleKeydown);

      initialized.set(root, () => {
        stopAutoplay();
        if (observer) observer.disconnect();
        window.removeEventListener("keydown", handleKeydown);
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll("[data-wc-ia]").forEach(initWarmcoreApplications);
    }

    function cleanupAll(scope) {
      (scope || document).querySelectorAll("[data-wc-ia]").forEach((root) => {
        const cleanup = initialized.get(root);
        if (cleanup) {
          cleanup();
          initialized.delete(root);
        }
      });
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => initAll(document));
    } else {
      initAll(document);
    }

    document.addEventListener("shopify:section:load", (event) => initAll(event.target));
    document.addEventListener("shopify:section:unload", (event) => cleanupAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warmcore-butterfly-proof-worlds"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mount = root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const path = root.querySelector('[data-flight-path]');
      const aura = root.querySelector('[data-flight-aura]');
      const butterfly = root.querySelector('[data-flight-butterfly]');
      const svg = root.querySelector('.wc-bpg__line');
      if (!path || !butterfly || !svg || !path.getTotalLength) return;
      const length = path.getTotalLength();
      path.style.strokeDasharray = `${length}`;
      path.style.strokeDashoffset = `${length}`;
      if (aura) { aura.style.strokeDasharray = `${length}`; aura.style.strokeDashoffset = `${length}`; }
      const placeButterfly = (point, angle, opacity) => {
        const svgPoint = svg.createSVGPoint();
        svgPoint.x = point.x;
        svgPoint.y = point.y;
        const screenPoint = svgPoint.matrixTransform(path.getScreenCTM());
        const rootBox = root.getBoundingClientRect();
        butterfly.style.transform = `translate3d(${screenPoint.x - rootBox.left - butterfly.offsetWidth / 2}px,${screenPoint.y - rootBox.top - butterfly.offsetHeight / 2}px,0) rotate(${angle}deg)`;
        butterfly.style.opacity = `${opacity}`;
      };
      let raf = 0;
      const render = () => {
        raf = 0;
        const rect = root.getBoundingClientRect();
        const travel = Math.max(1, root.offsetHeight - window.innerHeight * .4);
        const progress = Math.min(1, .12 + Math.max(0, -rect.top) / travel * .88);
        const point = path.getPointAtLength(length * progress);
        const before = path.getPointAtLength(Math.max(0, length * (progress - .002)));
        const after = path.getPointAtLength(Math.min(length, length * (progress + .002)));
        const angle = Math.atan2(after.y - before.y, after.x - before.x) * 180 / Math.PI + 90;
        const opacity = progress > .82 ? Math.pow((1 - progress) / .18, 1.35) : 1;
        placeButterfly(point, angle, opacity);
        path.style.strokeDashoffset = `${length * (1 - progress)}`;
        if (aura) aura.style.strokeDashoffset = `${length * (1 - progress)}`;
      };
      const request = () => { if (!raf) raf = requestAnimationFrame(render); };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const point = path.getPointAtLength(length * .12);
        placeButterfly(point, 0, 1);
      } else {
        addEventListener('scroll', request, { passive: true });
        addEventListener('resize', request);
        request();
      }
    };
    const all = root => (root || document).querySelectorAll('[data-wc-butterfly-proof]').forEach(mount);
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => all()) : all();
    document.addEventListener('shopify:section:load', event => all(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warmcore-embodied-interface"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mount = section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const items = [...section.querySelectorAll('[data-capability]')];
      const markers = [...section.querySelectorAll('[data-region-button]')];
      const headMarkers = [...section.querySelectorAll('[data-head-sensor]')];
      const image = section.querySelector('[data-focus-image]');
      const label = section.querySelector('[data-focus-label]');
      const focusDescription = section.querySelector('[data-focus-description]');
      const title = section.querySelector('[data-title]');
      const description = section.querySelector('[data-description]');
      const tags = section.querySelector('[data-tags]');
      const count = section.querySelector('[data-count]');
      const images = {
        eye: 'https://cdn.shopify.com/s/files/1/0634/6512/8035/files/eye.webp?v=1784263562',
        ear: 'https://cdn.shopify.com/s/files/1/0634/6512/8035/files/ear.webp?v=1784202656',
        mouth: 'https://cdn.shopify.com/s/files/1/0634/6512/8035/files/mouth.webp?v=1784202639',
        brain: 'https://cdn.shopify.com/s/files/1/0634/6512/8035/files/brain.webp?v=1784202655',
        arm: 'https://cdn.shopify.com/s/files/1/0634/6512/8035/files/hand_bone.webp?v=1784202656',
        leg: 'https://cdn.shopify.com/s/files/1/0634/6512/8035/files/foot_v2.webp?v=1784264109'
      };
      const unusedHeadCopy = {
        eye: ['Vision AI', 'Eye-level perception for face recognition, object detection, eye tracking, and scene awareness.', 'Object detection · Face recognition · Eye tracking'],
        ear: ['AI Voice Input', 'Near-field listening captures speech before the response engine replies.', 'Array microphone · Listening input · Voice response'],
        mouth: ['AI Voice', 'Low-latency speech output supports multilingual conversation and voice-clone response.', 'Multilingual · ~0.1s response · Voice clone'],
        brain: ['Memory & Emotion', 'Memory, personality settings, and selectable local models shape long-term response.', 'Local memory · Personality layer · Local model']
      };
      const headCopy = {
        eye: [section.dataset.eyeTitle, section.dataset.eyeDescription, section.dataset.eyeTags],
        ear: [section.dataset.earTitle, section.dataset.earDescription, section.dataset.earTags],
        mouth: [section.dataset.mouthTitle, section.dataset.mouthDescription, section.dataset.mouthTags],
        brain: [section.dataset.brainTitle, section.dataset.brainDescription, section.dataset.brainTags]
      };
      const setCopy = (data, index) => {
        title.textContent = data[0]; description.textContent = data[1]; tags.textContent = data[2];
        count.textContent = `${String(index + 1).padStart(2, '0')} / ${String(items.length).padStart(2, '0')}`;
      };
      const itemIndex = scene => items.findIndex(item => item.dataset.scene === scene);
      const itemCopy = (item, index) => setCopy([item.dataset.title, item.dataset.description, item.dataset.tags], index);
      const pressItem = index => items.forEach((item, itemIndexValue) => item.setAttribute('aria-pressed', String(itemIndexValue === index)));
      const enter = (region, scene, index) => {
        section.classList.remove('is-overview', 'is-head-detail', 'is-body-detail', 'has-head-sensor');
        section.dataset.region = region;
        markers.forEach(marker => marker.setAttribute('aria-pressed', String(marker.dataset.regionButton === region)));
        headMarkers.forEach(marker => marker.setAttribute('aria-pressed', 'false'));
        if (region === 'head') section.classList.add('is-head-detail');
        if (region === 'core' || region === 'arm' || region === 'leg') section.classList.add('is-body-detail');
        if (scene && images[scene]) {
          const copy = headCopy[scene];
          image.src = images[scene];
          label.textContent = copy ? copy[0] : items[index].dataset.title;
          focusDescription.textContent = copy ? copy[1] : items[index].dataset.description;
        }
        if (index >= 0) { pressItem(index); itemCopy(items[index], index); }
      };
      const reset = () => {
        section.classList.remove('is-head-detail', 'is-body-detail', 'has-head-sensor');
        section.classList.add('is-overview'); section.dataset.region = 'body';
        markers.forEach(marker => marker.setAttribute('aria-pressed', 'false'));
        headMarkers.forEach(marker => marker.setAttribute('aria-pressed', 'false'));
        if (items[0]) { pressItem(0); itemCopy(items[0], 0); }
      };
      markers.forEach(marker => marker.addEventListener('click', () => {
        const region = marker.dataset.regionButton;
        if (region === 'head') { enter('head', null, -1); setCopy(['Head sensory layer', 'Choose Eye, Ear, Mouth, or Brain to open its detailed sensory view.', 'Eye · Ear · Mouth · Brain'], 0); return; }
        const scene = region === 'core' ? 'core' : region;
        const index = itemIndex(scene);
        enter(region, scene, index);
      }));
      markers.forEach(marker => marker.addEventListener('click', () => {
        if (marker.dataset.regionButton === 'head') {
          setCopy([section.dataset.headLayerTitle, section.dataset.headLayerDescription, section.dataset.headLayerTags], 0);
        }
      }));
      headMarkers.forEach(marker => marker.addEventListener('click', () => {
        const scene = marker.dataset.headSensor;
        const mappedScene = scene === 'eye' ? 'eye' : scene === 'brain' ? 'brain' : 'mouth';
        const index = itemIndex(mappedScene);
        enter('head', scene, index);
        section.classList.add('has-head-sensor');
        headMarkers.forEach(button => button.setAttribute('aria-pressed', String(button === marker)));
        setCopy(headCopy[scene], index >= 0 ? index : 0);
      }));
      items.forEach((item, index) => item.addEventListener('click', () => {
        const scene = item.dataset.scene;
        if (scene === 'eye' || scene === 'mouth' || scene === 'brain') { enter('head', scene, index); section.classList.add('has-head-sensor'); }
        else if (scene === 'core') enter('core', scene, index);
        else if (scene === 'leg') enter('leg', scene, index);
        else enter('arm', scene, index);
      }));
      section.querySelector('[data-full-body]').addEventListener('click', reset);
      reset();
    };
    const all = root => (root || document).querySelectorAll('[data-wc-embodied]').forEach(mount);
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => all()) : all();
    document.addEventListener('shopify:section:load', event => all(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warmcore-product-motion"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.initialized === 'true') return;

    const slides = Array.from(root.querySelectorAll('[data-pm-slide]'));
    const dots = root.querySelector('[data-pm-dots]');
    const previous = root.querySelector('[data-pm-prev]');
    const next = root.querySelector('[data-pm-next]');
    const stagePrevious = root.querySelector('[data-pm-stage-prev]');
    const stageNext = root.querySelector('[data-pm-stage-next]');

    if (!slides.length) return;

    root.dataset.initialized = 'true';

    let index = 0;
    let autoplayTimer;
    let transitionTimer;
    let isTransitioning = false;

    const interval = Number(root.dataset.autoplayInterval) || 4200;
    const query = (selector) => root.querySelector(selector);

    if (dots) {
      slides.forEach((slide, slideIndex) => {
        const button = document.createElement('button');

        button.type = 'button';
        button.setAttribute('aria-label', `Show product ${slideIndex + 1}`);
        button.addEventListener('click', () => navigate(slideIndex));

        dots.appendChild(button);
      });
    }

    function go(nextIndex, force = false) {
      const targetIndex = (nextIndex + slides.length) % slides.length;

      if (!force && (isTransitioning || targetIndex === index)) return false;

      index = targetIndex;

      const active = slides[index];

      slides.forEach((slide, slideIndex) => {
        const previousIndex = (index - 1 + slides.length) % slides.length;
        const nextSlideIndex = (index + 1) % slides.length;
        const backIndex = (index + 2) % slides.length;

        slide.classList.toggle('is-active', slideIndex === index);
        slide.classList.toggle('is-left', slideIndex === previousIndex);
        slide.classList.toggle('is-right', slideIndex === nextSlideIndex);
        slide.classList.toggle('is-back', slideIndex === backIndex);
        slide.setAttribute('aria-current', String(slideIndex === index));
      });

      query('[data-pm-kicker]').textContent = active.dataset.kicker || '';
      const activeTitle = active.dataset.title || '';
      const activeBadge = active.dataset.badge || '';
      query('[data-pm-title]').childNodes[0].nodeValue = activeTitle === 'Interactive Model' && activeBadge === 'Flagship' ? root.dataset.pmDefaultHeading + ' ' : `${activeTitle} `;
      const badge = query('[data-pm-badge]');
      if (badge) badge.textContent = activeTitle === 'Interactive Model' && activeBadge === 'Flagship' ? '' : activeBadge;
      query('[data-pm-description]').textContent = active.dataset.description || '';
      query('[data-pm-link]').href = active.dataset.link || '#';

      const configuredAccent = (active.dataset.accent || '').toLowerCase();
      const originalAccent = active.dataset.originalAccent || '#9bbcff';
      const accent = configuredAccent && (configuredAccent !== '#7ddac7' || originalAccent === '#7ddac7') ? configuredAccent : originalAccent;

      root.style.setProperty('--pm-accent', accent);

      if (dots) {
        Array.from(dots.children).forEach((dot, dotIndex) => {
          dot.setAttribute('aria-current', String(dotIndex === index));
        });
      }

      window.clearTimeout(transitionTimer);

      isTransitioning = true;
      transitionTimer = window.setTimeout(() => {
        isTransitioning = false;
      }, 680);

      return true;
    }

    function stop() {
      window.clearTimeout(autoplayTimer);
    }

    function start() {
      stop();

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || slides.length < 2) return;

      autoplayTimer = window.setTimeout(() => {
        go(index + 1);
        start();
      }, interval);
    }

    function navigate(nextIndex) {
      if (go(nextIndex)) start();
    }

    if (previous) previous.addEventListener('click', () => navigate(index - 1));
    if (next) next.addEventListener('click', () => navigate(index + 1));
    if (stagePrevious) stagePrevious.addEventListener('click', () => navigate(index - 1));
    if (stageNext) stageNext.addEventListener('click', () => navigate(index + 1));

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          start();
        } else {
          stop();
        }
      });
    }, { threshold: 0.35 }).observe(root);

    go(0, true);
  }

  function initAll(scope = document) {
    scope.querySelectorAll('[data-wc-product-motion]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));

  if (document.readyState !== 'loading') {
    initAll();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
